module.exports = __webpack_public_path__ + "img/view-app-logs.a9c90802.png";